import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';



@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {

  content :any;
  isAlertMessage: any;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<DeleteComponent>,
    public dialog: MatDialog,) { }

  ngOnInit() {
     let route = this.router.url.split('/')[2].toLowerCase();
     console.log(route, this.router.url);
     
     if(route && USER_MGMT_CNST && USER_MGMT_CNST.CONTENT_OPTIONS && USER_MGMT_CNST.CONTENT_OPTIONS[route as keyof typeof USER_MGMT_CNST.CONTENT_OPTIONS]) {
       this.content = USER_MGMT_CNST.CONTENT_OPTIONS[route as keyof typeof USER_MGMT_CNST.CONTENT_OPTIONS];
     }
  }

  removeActiveTab(){
    this.dialogRef.close(true);
  }

}
